import { RouterModule, Routes } from '@angular/router';
import { IncidentFileComponent } from './incident-file.component';

const routes: Routes = [
	{ path: '', component: IncidentFileComponent },
];


export const incidentFileRoutes = RouterModule.forChild(routes);